import { createRouter, createWebHashHistory } from 'vue-router';
import i18n from '../i18n';
import HomePage from '../components/pages/HomePage.vue';
import CybersecurityPage from '../components/pages/CybersecurityPage.vue';
import AIEngineeringPage from '../components/pages/AIEngineeringPage.vue';
import FullStackPage from '../components/pages/FullStackPage.vue';
import ProjectsPage from '../components/pages/ProjectsPage.vue';
import ExperiencePage from '../components/pages/ExperiencePage.vue';
import FlappyBirdPage from '../components/pages/FlappyBirdPage.vue';
import ErrorPage from '../components/pages/ErrorPage.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage,
    meta: { titleKey: 'newPortfolio.meta.home' },
  },
  {
    path: '/cybersecurity',
    name: 'Cybersecurity',
    component: CybersecurityPage,
    meta: { titleKey: 'newPortfolio.meta.cyber' },
  },
  {
    path: '/ai-engineering',
    name: 'AIEngineering',
    component: AIEngineeringPage,
    meta: { titleKey: 'newPortfolio.meta.ai' },
  },
  {
    path: '/full-stack',
    name: 'FullStack',
    component: FullStackPage,
    meta: { titleKey: 'newPortfolio.meta.fullStack' },
  },
  {
    path: '/projects',
    name: 'Projects',
    component: ProjectsPage,
    meta: { titleKey: 'newPortfolio.meta.projects' },
  },
  {
    path: '/experience',
    name: 'Experience',
    component: ExperiencePage,
    meta: { titleKey: 'newPortfolio.meta.experience' },
  },
  {
    path: '/flappy',
    name: 'FlappyBird',
    component: FlappyBirdPage,
    meta: { titleKey: 'newPortfolio.meta.flappy' },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'Error',
    component: ErrorPage,
    meta: { titleKey: 'newPortfolio.meta.notFound' },
  },
];

const SCROLL_OFFSET = 96;

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return { el: to.hash, top: SCROLL_OFFSET, behavior: 'smooth' };
    }
    return { top: 0, behavior: 'smooth' };
  },
});

router.beforeEach((to) => {
  const titleKey = to.meta?.titleKey;
  const translatedTitle = titleKey ? i18n.global.t(titleKey) : to.name;
  document.title = `Christopher-William | ${translatedTitle}`;
});

export default router;
